/* eslint-disable max-len, sort-keys */
export const CHANGE_ALERT_FORM = 'app/Settings/Communications/CHANGE_ALERT_FORM';
export const CHANGE_PAPERLESS_FORM = 'app/Settings/Communications/CHANGE_PAPERLESS_FORM';
export const CHANGE_STEP = 'app/Settings/Communications/CHANGE_STEP';

export const CLOSE_MODAL_STATE = 'app/Settings/Communications/CLOSE_MODAL_STATE';

export const FETCH_ALERT_SETTINGS = 'app/Settings/Communications/FETCH_ALERT_SETTINGS';
export const FETCH_ALERT_SETTINGS_FAILURE = 'app/Settings/Communications/FETCH_ALERT_SETTINGS_FAILURE';
export const FETCH_ALERT_SETTINGS_SUCCESS = 'app/Settings/Communications/FETCH_ALERT_SETTINGS_SUCCESS';

export const FETCH_PAPERLESS_SETTING_ALL = 'app/Settings/Communications/FETCH_PAPERLESS_SETTING_ALL';
export const FETCH_PAPERLESS_SETTING_ALL_FAILURE = 'app/Settings/Communications/FETCH_PAPERLESS_SETTING_ALL_FAILURE';
export const FETCH_PAPERLESS_SETTING_ALL_SUCCESS = 'app/Settings/Communications/FETCH_PAPERLESS_SETTING_ALL_SUCCESS';

export const OPEN_MODAL_STATE = 'app/Settings/Communications/OPEN_MODAL_STATE';

export const PUT_ALERT_SETTINGS = 'app/Settings/Communications/PUT_ALERT_SETTINGS';
export const PUT_ALERT_SETTINGS_FAILURE = 'app/Settings/Communications/PUT_ALERT_SETTINGS_FAILURE';
export const PUT_ALERT_SETTINGS_SUCCESS = 'app/Settings/Communications/PUT_ALERT_SETTINGS_SUCCESS';

export const PUT_PAPERLESS_SETTING = 'app/Settings/Communications/PUT_PAPERLESS_SETTING';
export const PUT_PAPERLESS_SETTING_FAILURE = 'app/Settings/Communications/PUT_PAPERLESS_SETTING_FAILURE';
export const PUT_PAPERLESS_SETTING_SUCCESS = 'app/Settings/Communications/PUT_PAPERLESS_SETTING_SUCCESS';

export const RESET_FORM_STATE = 'app/Settings/Communications/RESET_FORM_STATE';
export const RESET_STATUS_STATE = 'app/Settings/Communications/RESET_STATUS_STATE';
export const SET_SELECTED_LOAN = 'app/Settings/Communications/SET_SELECTED_LOAN';

export const FETCH_ALERT_SETTINGS_ERROR_MESSAGE = 'There was an issue fetching your email and text message notification settings.';
export const FETCH_PAPERLESS_SETTING_ALL_ERROR_MESSAGE = 'There was an issue fetching your paperless billing settings.';
export const PUT_ALERT_SETTINGS_ERROR_MESSAGE = 'There was an issue updating your email and text message notification settings.';
export const PUT_PAPERLESS_SETTING_ERROR_MESSAGE = 'There was an issue updating your paperless billing settings.';

export const ADD_MOBILE_NUMBER_LABEL = 'Add phone number.';
export const ADD_MOBILE_NUMBER_TEXT = 'To enable text message notifications, please provide a mobile number.';

export const FETCH_ERROR_PROPS = {
  body: 'Please try again later. For assistance, contact {{customerServicePhoneNumber}}.',
  title: 'There was a problem with your request',
};

export const NOTIFICATIONS_TEXT = 'Opt-in to receive notifications about important account related activities.';

export const PAPERLESS_TOGGLE_TEXT_DICT = {
  Disable_Request_Processing: 'Off (Pending)',
  Disable_Requested: 'Off (Pending)',
  Disabled: 'Off',
  Enable_Request_Processing: 'On (Pending)',
  Enable_Requested: 'On (Pending)',
  Enabled: 'On',
  Not_Available: 'Unavailable',
  Not_Enabled: 'Off',
};

export const PAPERLESS_TOOLTIP_COPY = 'With paperless billing you can access all your statements safely from your device. Get instantly notified once a statement is available and reduce paper clutter.';

export const PUT_COMMUNICATIONS_SUCCESS_DICT = {
  alerts: {
    heading: 'Success! Your text and email notifications have been updated',
    text: 'You can change your preferences at anytime in the communication settings.',
  },
  enrollPaperless: {
    heading: 'Thank you for enrolling in paperless billing',
    text: 'Your request has been made and will be processed. An email will be sent to you confirming that we have received your request.',
  },
  unenrollPaperless: {
    heading: 'Success! We received your request to unenroll from paperless billing',
    text: 'Your request has been made and will be processed. An email will be sent to you confirming that we have received your request.',
  },
};

export const UNENROLL_PAPERLESS_MODAL_DICTIONARY = {
  text: 'If you unenroll, you will stop receiving online statements. Paper statements will be sent to your mailing address instead.',
  title: 'Are you sure you want to unenroll from paperless billing?',
};
